import { Component, Input, OnInit } from '@angular/core';
import { PageFlags } from '../../models/pageFlags.model';
import { Location } from '@angular/common'
import  {properties}  from 'src/environments/properties';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  @Input() pageFlags: PageFlags = {
    isCouponsDealsPage: false,
    isBonusPathPage: false,
    isOfferDetailsPage: false,
    isDiscoveryPage: false
  };
  public _window: any = window;
  public banner: string = '';
  public displayableBannerName: string = '';
  constructor(private location: Location) { }

  ngOnInit(): void {
    this.banner = this._window['AB']['userInfo']['banner'];
    this.displayableBannerName =  properties.displayableBannerNames[this.banner as keyof typeof properties.displayableBannerNames] || this._window['AB']['userInfo']['displayableBanner'];
  }

  goBackClick() {
    const getSelectedFiltersFromLS: any = localStorage.getItem('selectedFiltersMyList');
    if (getSelectedFiltersFromLS) {
      const selectedFiltersFromLS = JSON.parse(getSelectedFiltersFromLS);
      const data = {
        'filterList': selectedFiltersFromLS['filterList'],
        'pageUrl': window.location.pathname
      }
      console.warn(data);
      localStorage.setItem('selectedFiltersMyList', JSON.stringify(data));
    }
    this._window.history.back();
  }

}
